/** Browser voices may belong to other cloud providers. Use local or Google/Apple voices only. */
export function allowedHebrewVoice(voices: SpeechSynthesisVoice[]): SpeechSynthesisVoice | undefined {
  return voices.filter(v => /^(he|iw)(-|$)/i.test(v.lang))
    .filter(v => v.localService || /google|com\.apple\./i.test(v.name + " " + v.voiceURI))
    .sort((a,b) => Number(b.localService) - Number(a.localService))[0];
}
